import React from 'react';

function PaymentSystemUnavailable() {
  const imgClick = () => {
    window.history.back();
  };
  const maintenanceImg = (
    <button type='button' className='imgButton' onClick={imgClick}>
      <div className='maintenance' />
    </button>
  );

  return <div>{maintenanceImg}</div>;
}
export default PaymentSystemUnavailable;
